import type { IncidentStatus } from '@evimo/types';

export const STATUS_DISPLAY: Record<
  IncidentStatus,
  { color: string; order: number; icon: string }
> = {
  NEW: { color: '#8d969e', order: 10, icon: 'circle' },
  RCA_IN_PROGRESS: { color: '#ec7e00', order: 20, icon: 'search' },
  REMOTE_PROPOSED: { color: '#1e6df6', order: 30, icon: 'send' },
  REMOTE_APPLIED: { color: '#1e6df6', order: 40, icon: 'check-circle' },
  FIELD_REQUIRED: { color: '#722ed1', order: 50, icon: 'tool' },
  FIELD_IN_PROGRESS: { color: '#722ed1', order: 60, icon: 'wrench' },
  BLOCKED: { color: '#e23b4a', order: 70, icon: 'pause' },
  RESOLVED: { color: '#00a87e', order: 80, icon: 'check' },
  CLOSED: { color: '#8d969e', order: 90, icon: 'archive' },
};

export const openIncidentStatuses = [
  'NEW',
  'RCA_IN_PROGRESS',
  'REMOTE_PROPOSED',
  'REMOTE_APPLIED',
  'FIELD_REQUIRED',
  'FIELD_IN_PROGRESS',
  'BLOCKED',
] as const satisfies readonly IncidentStatus[];

export const resolvedIncidentStatuses = [
  'RESOLVED',
  'CLOSED',
] as const satisfies readonly IncidentStatus[];

export function isResolvedIncidentStatus(status: IncidentStatus): boolean {
  return (resolvedIncidentStatuses as readonly IncidentStatus[]).includes(
    status,
  );
}

export function isOpenIncidentStatus(status: IncidentStatus): boolean {
  return !isResolvedIncidentStatus(status);
}

export function getIncidentStatusGroup(
  status: IncidentStatus,
): 'open' | 'resolved' {
  return isResolvedIncidentStatus(status) ? 'resolved' : 'open';
}
